import { render, staticRenderFns } from "./SocioEmpresaContrato.vue?vue&type=template&id=53d65378&"
import script from "./SocioEmpresaContrato.vue?vue&type=script&lang=js&"
export * from "./SocioEmpresaContrato.vue?vue&type=script&lang=js&"
import style0 from "./SocioEmpresaContrato.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports